import CreateTimeline from './timeline/CreateTimeline';
import TimelineNav from './timeline/TimelineNav';
import FloatingBg from './animations/FloatingBg';
var newTimeline = null;

var initiateTimeline = function initiateTimeline() {
  var pagePaths = document.querySelector('.page-paths');
  var items = document.querySelectorAll('.large-heading');

  if (pagePaths && items.length > 0) {
    newTimeline = new CreateTimeline(pagePaths, 'page-paths', items);
    newTimeline.init();
  }

  var timeline = document.querySelector('.timeline');

  if (timeline && items.length > 0) {
    var timelineProgress = timeline.querySelector('.timeline__bar');
    var timelineItems = timeline.querySelectorAll('.timeline__link');
    var newTimelineNav = new TimelineNav(timeline, timelineProgress, items, timelineItems);
    newTimelineNav.init();
  }
};

var initiateFloatingBackgrounds = function initiateFloatingBackgrounds() {
  var background = document.querySelector('.floats');

  if (background) {
    var newBackground = new FloatingBg(background, background.querySelectorAll('.floats__source'));
    newBackground.init();
  }
};

window.addEventListener('load', function () {
  initiateTimeline();
  initiateFloatingBackgrounds();
});
window.addEventListener('resize', function () {
  if (newTimeline !== null) {
    newTimeline.destroy();
    newTimeline.init();
  }
});